import { Controller } from "@hotwired/stimulus"

/** Mobile collapsible sidebar; tablet horizontal scroll strip; desktop always expanded. */
export default class extends Controller {
  static targets = ["details"]

  connect() {
    this.mobileMq = window.matchMedia("(max-width: 768px)")
    this.tabletMq = window.matchMedia("(min-width: 769px) and (max-width: 1023px)")
    this.desktopMq = window.matchMedia("(min-width: 1024px)")

    this._onViewportChange = () => this.applyOpenState()
    this.desktopMq.addEventListener("change", this._onViewportChange)
    this.applyOpenState()
    this.scrollActiveIntoView()

    this._closeOnNavigate = this.closeOnNavigate.bind(this)
    this.element.addEventListener("click", this._closeOnNavigate)
  }

  disconnect() {
    this.desktopMq.removeEventListener("change", this._onViewportChange)
    this.element.removeEventListener("click", this._closeOnNavigate)
  }

  applyOpenState() {
    if (this.desktopMq.matches || this.tabletMq.matches) {
      this.detailsTarget.open = true
    }
  }

  closeOnNavigate(event) {
    if (!this.mobileMq.matches) return

    const link = event.target.closest("a.app-sidebar-item")
    if (!link) return

    this.detailsTarget.open = false
  }

  scrollActiveIntoView() {
    if (!this.tabletMq.matches) return

    const active = this.element.querySelector(".app-sidebar-item.is-active")
    if (!active) return

    active.scrollIntoView({ inline: "start", block: "nearest", behavior: "instant" })
  }
}
